import React, { useEffect, useState } from 'react';
import canvasBuccalSx from './CanvasBuccal.styles';
import { useTheme } from '@mui/material/styles';
import BuccalHandler from 'svgHandlers/Buccal';
import SVGHelper from 'svgHandlers/helper';
import PenpalContextBuccal from '../PenpalContextBuccal';
import { Box } from '@mui/material';



const CanvasBuccal = ({ penPal }) => {
	const canvasRef  = React.createRef(),
		  theme      = useTheme(),
		  sx         = canvasBuccalSx(theme),
		  [ helper ] = useState(new SVGHelper(penPal)),
		  [ svg ]    = useState(new BuccalHandler(penPal, helper));


	useEffect(() => {
		console.log('exists', penPal.canvas.exists('buccal'));
		if(svg) {
			console.log('running canvas init');
			svg.init(canvasRef.current);
		}

		return () => {
			if(svg) {
				console.log('destroying canvas');
				svg.destroy();
			}
		};
	}, []);


	if(penPal && penPal.canvas.exists('buccal')) {
		penPal.sizeCanvas('buccal', 0);
	}


	return (
		<PenpalContextBuccal.Provider value={penPal}>
			<Box ref={canvasRef} sx={sx.buccalContainer} />
		</PenpalContextBuccal.Provider>
	);

};


export default CanvasBuccal;
